import { blue as blueColor, green as greenColor, grey as greyColor, purple as purpleColor, red as redColor } from '@mui/material/colors';

import { PaymentListItem } from '../../../apis/paymentApi';

export const paymentStatusColors = {
  canceled: greyColor[500],
  failed: redColor[500],
  partialrefund: greyColor[500],
  pending: blueColor[500],
  refunded: greyColor[500],
  succeeded: greenColor[500],
  voided: purpleColor[500],
};

export const filterStatuses = [
  { label: 'Canceled', background: paymentStatusColors.canceled, lightText: true },
  { label: 'Failed', background: paymentStatusColors.failed, lightText: true },
  { label: 'Partial Refund', background: paymentStatusColors.partialrefund, lightText: true },
  { label: 'Pending', background: paymentStatusColors.pending, lightText: true },
  { label: 'Refund Pending', background: paymentStatusColors.pending, lightText: true },
  { label: 'Refunded', background: paymentStatusColors.refunded, lightText: true },
  { label: 'Succeeded', background: paymentStatusColors.succeeded, lightText: true },
  { label: 'Void Pending', background: paymentStatusColors.pending, lightText: true },
  { label: 'Voided', background: paymentStatusColors.voided, lightText: true },
];

export const getPaymentDisplayStatus = (item: PaymentListItem) => {
  if (item.status === 'PartialRefund') {
    return 'Partial Refund';
  } else if (item.status === 'RefundPending') {
    return 'Refund Pending';
  } else if (item.status === 'VoidPending') {
    return 'Void Pending';
  }

  return item.status;
};
